import { Component, Input, OnInit } from '@angular/core';
import { Router } from './common';
import { AppConstants } from './common/constants';
import { IMenuOption } from './models';
import { AuthenticationService, BlockUiHandlerService, SessionService, SideBarService, StorageService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  opened: boolean = false;
  currentSession: any;
  sidebarMode = 'push';
  menu: IMenuOption[];

  @Input() currentUser: string;

  constructor(
    private router: Router,
    private sidebarService: SideBarService,
    public sessionService: SessionService,
    private blockUI: BlockUiHandlerService,
    private authtenticationService: AuthenticationService,
    private storageService: StorageService
  ) {
    this.menu = AppConstants.GetMenu;
    this.sidebarService.toggler.subscribe((toggle) => (this.opened = toggle));
    this.validateSession();
    this.authtenticationService.currentUser.subscribe(x => this.currentUser = x);
    
  }
  ngOnInit(): void {
    this.opened = this.currentUser !== null
  }

  openedChange($event) { }

  onClickMenuOption(menuOption: IMenuOption) {
    this.menu.forEach(x => {
      x.Selected = false;
      if (x.Children.length > 0) {
        x.Children.forEach(y => y.Selected = false);
      }
    });

    if (menuOption.Name === 'Salir') {
      this.opened = false;
      this.sidebarService.currentPath.next('Inicio');
      this.sessionService.logOut();

    }
    else {
      menuOption.Selected = true;
      if (menuOption.Children.length === 0) {
        this.sidebarService.currentPath.next(menuOption.Name);
        this.router.navigateByUrl(menuOption.Route);
      }
    }

  }

  validateSession() {
    if (this.sessionService.anyActiveSession())
      this.sessionService.loadSessionFromLocalStorage();
  }

  PrintReport(reportId: number) {
    this.router.navigateByUrl(`print-report/${reportId}`);
  }

  TriggerPath(_path: string) {
    this.router.navigate(['/', _path]);
  }
}
